import { bffServiceClient } from '../../packages/request/clients';
import { getResult } from 'helpers/request';
import { IOrgChartStaffResult } from '../../interfaces/orgchart';

const getUserInfo = (): Promise<IOrgChartStaffResult> => {
  return bffServiceClient.get('/staff/detail').then(getResult);
};

export default { getUserInfo };
